module.exports = __webpack_public_path__ + "img/Wing_feathers_DiffuseColor.db449d0.png";